import facultyList from './sliders/facultyList';
import genericCards from './sliders/genericCards';
import headerColumns from './sliders/headerColumns';
import inverseBox from './sliders/inverseBox';
import partnerShowcase from './sliders/partnerShowcase';
import programmeShowcase from './sliders/programmeShowcase';
import testimonials from './sliders/testimonials';
import offer from './sliders/offer';
import programmeSlider from './sliders/programmeSlider';

document.addEventListener('DOMContentLoaded', () => {
    facultyList.init();
    genericCards.init();
    headerColumns.init();
    inverseBox.init();
    partnerShowcase.init();
    programmeShowcase.init();
    testimonials.init();
    offer.init();
    programmeSlider.init();
});
